import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { locations, locationPath } from '../data/locations';
import { company } from '../data/company';
import './AreasSection.css';

// "From George to wherever you're building": delivery map + one-click links to each area page.
function AreasSection({ title = "From George to wherever you're building", showHubLink = true }) {
  return (
    <section
      className="section section-light areas-section"
      style={{ '--areas-bg': 'url(/South-Africa-Delivery-Routes.jpg)' }}
    >
      <div className="container split">
        <div>
          <span className="pill">Delivery areas</span>
          <h2 className="section-title">{title}</h2>
          <p className="section-subtitle">
            Collect from our showroom in Joubert Industria, George, or have it delivered across the Garden Route,
            Klein Karoo, Western Cape and Eastern Cape.
          </p>
          <div className="chips mt-3">
            {locations.map((l) => (
              <Link key={l.slug} to={locationPath(l)} className="chip">
                {l.name.replace(/^the /, '')}
              </Link>
            ))}
          </div>
          {showHubLink && (
            <Link to="/delivery-areas" className="text-link areas-hub-link">
              All delivery areas <Icon name="arrow" size={16} />
            </Link>
          )}
        </div>
        <img
          className="areas-map"
          src="/South-Africa-Delivery-Routes.jpg"
          alt={`Map of ${company.name} delivery routes from George to Cape Town, Mossel Bay, Knysna, Tsitsikamma and Port Elizabeth`}
          width="725"
          height="484"
          loading="lazy"
        />
      </div>
    </section>
  );
}

export default AreasSection;
